const child = {
  namespaced: true,
  state: () => {
    return {
      childId: ''
    };
  },
  mutations: {
    SET_CHILD_ID(state, id) {
      state.childId = id;
    }
  }
};

export default child;



// WEBPACK FOOTER //
// ./src/store/modules/child.js